import { Box, Modal, TableCell, TableRow, Snackbar } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { TouchpointForm } from "./TouchpointForm";
import ClientProvider from "../../../../modules/ClientProvider";
import { useAuth0 } from "@auth0/auth0-react";

const typeLabel = {
    "default": "Default",
    "manual": "Manual",
    "auto": "Automated"
};

const statusLabel = {
    "draft": "Draft",
    "scheduled": "Scheduled",
    "active": "Active",
    "completed": "Completed"
};

export const AdminTouchpoint = ({ project, touchpoint, reloadTouchpoints }: any) => {
    const [editMode, setEditMode] = useState(false);
    const adminTouchpointClient = ClientProvider.provideAdminTouchpointClient();
    const { getAccessTokenSilently } = useAuth0();
    const [notificationMessage, setNotificationMessage] = useState("");
    const [notificationSending, setNotificationSending] = useState(false);

    const sendNotifications = async () => {
        const accessToken = await getAccessTokenSilently();
        const { data, error } = await adminTouchpointClient.sendTouchpointNotifications(accessToken, touchpoint.uuid);
        if (!error) {
            setNotificationMessage("Notifications sent successfully");
            setNotificationSending(false);
        } else {
            setNotificationMessage("Failed to send notifications");
            setNotificationSending(false);
        }
    };

    const handleEdit = (e: any) => {
        e.preventDefault();
        e.stopPropagation();
        setEditMode(true);
    };

    const handleSendNotifications = (e: any) => {
        setNotificationSending(true);
        e.preventDefault();
        e.stopPropagation();
        sendNotifications();
    };

    return (
        <>
            <TableRow>
                <TableCell>{touchpoint.name}</TableCell>
                <TableCell>{touchpoint.uuid}</TableCell>
                <TableCell className="center">{typeLabel[touchpoint.type as keyof typeof typeLabel]}</TableCell>
                <TableCell className="center">{statusLabel[touchpoint.status as keyof typeof statusLabel]}</TableCell>
                <TableCell className="center">
                    {touchpoint.scheduled_at ? new Date(touchpoint.scheduled_at).toLocaleDateString() : "---"}
                </TableCell>
                <TableCell className="center">
                    {touchpoint.started_at ? new Date(touchpoint.started_at).toLocaleDateString() : "---"}
                </TableCell>
                <TableCell className="center">
                    {touchpoint.completed_at ? new Date(touchpoint.completed_at).toLocaleDateString() : "---"}
                </TableCell>
                <TableCell className="center">{touchpoint.viewpoints?.length || 0}</TableCell>
                <TableCell className="center">
                    <Box sx={{ display: "flex", gap: 2, flexDirection: "row", alignItems: "center", justifyContent: "center" }}>
                        <span className="link" onClick={handleEdit}>
                            <FontAwesomeIcon icon="edit" />
                        </span>
                        <span className="link" onClick={handleSendNotifications}>
                            <FontAwesomeIcon icon={notificationSending ? "spinner" : "envelope"} spin={notificationSending} />
                        </span>
                    </Box>
                </TableCell>
            </TableRow>

            <Modal 
                open={editMode} 
                onClose={() => setEditMode(false)}
            >
                <Box sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: '80%',
                    maxHeight: '90vh',
                    bgcolor: 'background.paper',
                    boxShadow: 24,
                    overflowY: 'auto'
                }}>
                    <TouchpointForm
                        project={project}
                        touchpointUuid={touchpoint.uuid}
                        editMode={editMode}
                        setEditMode={setEditMode}
                        reloadTouchpoints={reloadTouchpoints}
                    />
                </Box>
            </Modal>
        </>
    );
}; 